// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const OpenYoungFiscalDataStep1 = require('components/myProfile/openYoungFiscalData/openYoungFiscalDataStep1/openYoungFiscalDataStep1');
const OpenYoungFiscalDataStep2 = require('components/myProfile/openYoungFiscalData/openYoungFiscalDataStep2/openYoungFiscalDataStep2');
const OpenYoungFiscalDataSuccess = require('components/myProfile/openYoungFiscalData/openYoungFiscalDataSuccess/openYoungFiscalDataSuccess');
const OpenYoungFiscalDataError = require('components/myProfile/openYoungFiscalData/openYoungFiscalDataError/openYoungFiscalDataError');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

// @actions
const openYoungProfileDetailsActions = require('actions/openYoungProfileDetails');
const openYoungTaxDataActions = require('actions/openYoungTaxData');

// @utilities
const { PROC_OPEN_YOUNG_FISCAL_DATA } = require('utilities/tagging');

class OpenYoungFiscalDataEditView extends React.Component {

    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            fillOpenYoungProfile,
            history,
            immOpenYoungProfileDetails
        } = this.props;
        if (immOpenYoungProfileDetails.get('fetchSuccess')) {
            fillOpenYoungProfile(immOpenYoungProfileDetails.get('countriesTributation'));
        } else {
            history.push(`/myprofile/openyoung-profiles`);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleCancel() {
        const { history, match: { params: { profileIndex } } } = this.props;
        history.push(`/myprofile/openyoung-profile-details/${profileIndex}`);
    }

    buildWizard() {
        const {
            immOpenYoungTaxData,
            immOpenYoungProfileDetails,
            setVisibleStep,
            setWillCancel,
            updateProfileDetailsData,
            validateStep,
        } = this.props;

        const wizardActions = {
            cancel: this.handleCancel,
            finish: () => updateProfileDetailsData('fiscalData'),
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const immSteps = immOpenYoungProfileDetails.get('steps');

        return (
            <Wizard
                actions={wizardActions}
                immSteps={immSteps}
                processType={PROC_OPEN_YOUNG_FISCAL_DATA}
                showPreLeaveModal={true}
                stepsAmount={immSteps.size}
                visibleStep={immOpenYoungProfileDetails.get('visibleStep')}
            >
                <WizardStep
                    cancelButton={true}
                    position="first"
                >
                    <OpenYoungFiscalDataStep1
                        immOpenYoungTaxData={immOpenYoungTaxData}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    immFinalButton="openYoungFiscalData-openYoungFiscalData_submit"
                    onBackClick={false}
                    position="last"
                    SignaturePatternButton={SignaturePatternButton}
                >
                    <OpenYoungFiscalDataStep2
                        immOpenYoungTaxData={immOpenYoungTaxData}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildWizardError() {
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <OpenYoungFiscalDataError />
            </div>
        );
    }

    buildWizardSuccess() {
        const { immOpenYoungTaxData } = this.props;
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <OpenYoungFiscalDataSuccess
                    immOpenYoungTaxData={immOpenYoungTaxData}
                />
            </div>
        );
    }

    buildFiscalDataForm() {
        const content = this.buildWizard();
        const boxBody = (
            <OKMessage type="important">
                <FormattedText value="profile-boxBody" />
            </OKMessage>
        );
        const boxTitle = formatText('profile-boxTitle');
        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    {content}
                </div>

                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-12 grid-view--variable-cell-separation">
                            <ContactInfoBox
                                boxTitle={boxTitle}
                                boxBody={boxBody}
                                hasMessage={true}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack pageTitle={formatText('breadcrumb-personalInformation')} />
                        </div>
                        <div className="col-xs-12 grid-view--fix-cell-separation">
                            <CommercialAds path={'edit'} type="banner-a" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immOpenYoungProfileDetails, match: { params: { profileIndex } } } = this.props;
        const breadcrumbConfig = [{
            text: formatText('breadcrumb-personalInformation'),
            url: '/myprofile/edit'
        }, {
            text: formatText('breadcrumb-breadcrumb_openYoungInformation'),
            url: '/myprofile/openyoung-profiles'
        }, {
            text: formatText('breadcrumb-breadcrumb_personalDataOpenYoungInformation'),
            url: `/myprofile/openyoung-profile-details/${profileIndex}`
        }, {
            text: formatText('breadcrumb-breadcrumb_editOpenYoungInformation'),
            url: ''
        }];
        let content;
        if (immOpenYoungProfileDetails.get('isFetching')) {
            content = (
                <OKSectionBox>
                    <LoadingSection />
                </OKSectionBox>
            );
        } else if (immOpenYoungProfileDetails.get('submitSuccessful')) {
            content = this.buildWizardSuccess();
        } else if (immOpenYoungProfileDetails.get('error')) {
            content = this.buildWizardError();
        } else if (immOpenYoungProfileDetails.get('fetchSuccess')) {
            content = this.buildFiscalDataForm();
        }

        return (
            <div className="open-young-fiscal-data-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover>
                            <OKHeaderSubPage
                                breadcrumbConfig={breadcrumbConfig}
                                finalTitle={getFinalTitle('openYoungProfileDetails-openYoungProfileDetails_formsTitle')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungFiscalDataEditView.propTypes = {
    getOpenYoungProfileDetails: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immOpenYoungTaxData: PropTypes.object,
    immOpenYoungProfileDetails: PropTypes.object.isRequired,
    match: PropTypes.object,
    reset: PropTypes.func.isRequired,
    fillOpenYoungProfile: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    updateProfileDetailsData: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
}

module.exports.constructor = OpenYoungFiscalDataEditView;

module.exports.OpenYoungFiscalDataEditView = connect(
    state => ({
        immOpenYoungProfileDetails: state.openYoungProfileDetails,
        immOpenYoungTaxData: state.openYoungTaxData,
    }), {
    getOpenYoungProfileDetails: openYoungProfileDetailsActions.getOpenYoungProfileDetails,
    reset: openYoungProfileDetailsActions.reset,
    fillOpenYoungProfile: openYoungTaxDataActions.fillOpenYoungProfile,
    setVisibleStep: openYoungProfileDetailsActions.setVisibleStep,
    setWillCancel: openYoungProfileDetailsActions.setWillCancel,
    updateProfileDetailsData: openYoungProfileDetailsActions.updateProfileDetailsData,
    validateStep: openYoungProfileDetailsActions.validateFiscalDataStep,
}
)(withRouter(OpenYoungFiscalDataEditView));
